export default "__VITE_ASSET__8MwHfuRI__"